import type {ReactAction} from '@netx/core/bootstrap';
import {performLegacyAction} from '@netx/core-next/utils/actions/performLegacyAction';
import {faClock} from '@fortawesome/pro-solid-svg-icons';
import {assetExpirationEnabled} from '../enablers/assetExpirationEnabled';
import {AssetExpirationListLabel} from '../locales';

export const assetExpirationActionListRouteIcon = faClock;

/**
 * Route to expiring assets
 * @param params
 * @returns Action
 */
export const assetExpirationActionListRoute = (
	params?: Partial<ReactAction>,
): ReactAction => ({
	name: 'asset-expiration-list-route',
	cb: () => performLegacyAction('asset:expirations:route'),
	enableTest: () => assetExpirationEnabled(),
	icon: assetExpirationActionListRouteIcon,
	get label() {
		return AssetExpirationListLabel.ROUTE;
	},
	routeMatch: /^assets\/expiring(\/?)/,
	...params,
});
